import { useState, useEffect } from "react";
import {
  useDisclosure,
  Image,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  IconButton,
  Box
} from "@chakra-ui/react";
import { CloseIcon } from "@chakra-ui/icons";
function ClickableImage({ dataUriOrBase64, alt = "image" }) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [blobUrl, setBlobUrl] = useState("");

  useEffect(() => {
    if (!dataUriOrBase64) return;

    let base64Data = dataUriOrBase64;
    let mimeType = "image/png";

    // 如果已經有 data:image/... 前綴
    if (dataUriOrBase64.startsWith("data:image")) {
      const [meta, b64] = dataUriOrBase64.split(",");
      base64Data = b64;
      mimeType = meta.match(/data:(image\/[a-zA-Z0-9+]+);base64/)[1] || "image/png";
    }

    // Base64 → Uint8Array
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    // 建立 Blob
    const blob = new Blob([byteArray], { type: mimeType });
    const url = URL.createObjectURL(blob);
    setBlobUrl(url);

    return () => URL.revokeObjectURL(url);
  }, [dataUriOrBase64]);

  return (
    <>
      <Image
        src={blobUrl}
        alt={alt}
        maxH="200px"
        borderRadius="md"
        objectFit="cover"
        cursor="zoom-in"
        onClick={onOpen}
      />
    <Modal isOpen={isOpen} onClose={onClose} size="4xl" isCentered>
    <ModalOverlay />
    <ModalContent bg="transparent" boxShadow="none">
        <ModalBody p={0} display="flex" justifyContent="center" alignItems="center">
        <Box position="relative" display="inline-block">
            <Image src={blobUrl} alt={alt} maxH="80vh" borderRadius="md" />
            <IconButton
            icon={<CloseIcon />}
            aria-label="Close"
            size="sm"
            variant="ghost"
            color="white"
            position="absolute"
            top="8px"
            right="8px"
            onClick={onClose}
            _hover={{ bg: "blackAlpha.500" }}
            />
        </Box>
        </ModalBody>
    </ModalContent>
    </Modal>
    </>
  );
}

export default ClickableImage;
